import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../util/withRouter';
import Confirm from '../../components/Confirm/Confirm';
import { Col, Row, Button, Tooltip, OverlayTrigger, Dropdown, DropdownButton, Form} from 'react-bootstrap';
import CheckBox from '../../components/Checkbox/Checkbox';

import { getUsers, saveUsers } from './PermissionsActions';
import { getDashboards } from '../Dashboards/DashboardsActions';

import pagination from '../../util/pagination';
import throttle from '../../util/throttle';

import Loading from '../../components/Loading/Loading';
import Header from '../../components/Header/Header';


import arrowSortIcon from '../../assets/img/arrow-down.svg';
import saveIcon from '../../assets/img/save.svg';
import editIcon from '../../assets/img/edit.svg';

import filterImage from '../../assets/images/filter-icon.svg';
import settingIcon from '../../assets/images/settings-gray-icon.svg';

// Import Style
import './Permissions.scss';
import _ from 'lodash';

class Permissions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      filter: 'all',
      sort: 'name',
      search: '',
      page: 1,
      viewAll: false,
      editAll: false,
      deleteAll: false,
      hasChanges: false,
      model: {
        users: [],
      },
      filterOptions: [
        {
          name: 'All',
          value: 'all'
        },
        {
          name: 'Full access',
          value: 'full'
        },
        {
          name: 'View access',
          value: 'view'
        },
        {
          name: 'Edit access',
          value: 'edit'
        },
        {
          name: 'Delete access',
          value: 'delete'
        },
        {
          name: 'No access',
          value: 'no-access'
        },
      ],
      sortName: [
        {
          name: 'Name: A to Z',
          value: 'name'
        },
        {
          name: 'Name: Z to A',
          value: '-name'
        }
      ],
      sortEmail: [
        {
          name: 'Email: A to Z',
          value: 'email'
        },
        {
          name: 'Email: Z to A',
          value: '-email'
        }
      ]
    };

    this.getUsersThrottled = throttle(this.getUsers, 500, this);
  }

  componentDidMount() {
    if (!this.props.dashboards.length) {
      this.props.getDashboards();
    }
    this.getUsers();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dashboards !== this.props.dashboards || prevProps.users !== this.props.users) {
      this.setData();
    }
  }

  setData = () => {
    const model = this.getModel();
    const name = this.getLabel();

    const viewAll = this.checkIfAllSelected(model.users, 'view');
    const editAll = this.checkIfAllSelected(model.users, 'edit');
    const deleteAll = this.checkIfAllSelected(model.users, 'delete');

    this.setState({
      viewAll,
      editAll,
      deleteAll,
      model,
      name,
    }, this.checkChanges);
  }

  getModel = () => {
    const { users } = this.props;
    const model = { users: [] };
    const { id } = this.props.routeParams;

    _.forEach(users, u => {
      const dashboard = _.find(u.dashboards, { dashboardId: id });
      model.users.push({
        name: u.name,
        email: u.email,
        userId: u.userId,
        invitationEmail: u.invitationEmail,
        pending: u.pending,
        manageDashboards: u.manageDashboards,
        manageDashboardsViewOnly: u.manageDashboardsViewOnly,
        view: u.manageDashboards || u.manageDashboardsViewOnly || dashboard && dashboard.view,
        edit: u.manageDashboards || dashboard && dashboard.edit,
        delete: u.manageDashboards || dashboard && dashboard.delete,
      });
    });

    return model;
  }

  checkIfAllSelected = (users, access) => {
    const count = _.filter(users, u => {
      return !!u[access] || u.manageDashboards || u.manageDashboardsViewOnly;
    }).length;

    return count == users.length;
  }

  getLabel = () => {
    const { id } = this.props.routeParams;
    const dashboard = _.find(this.props.dashboards, { _id: id });
    return dashboard && (dashboard.label || dashboard.name) || '';
  };

  checkChanges = () => {
    const { users } = this.props;
    const { model } = this.state;
    const { id } = this.props.routeParams;

    let hasChanges = false;

    for (let u of users) {
      const dashboard = _.find(u.dashboards, { dashboardId: id });
      const user = _.find(model.users, { userId: u.userId });

      if (user && !user.manageDashboards && !user.manageDashboardsViewOnly) {
        if (!dashboard && (user.view || user.edit || user.delete)) {
          hasChanges = true;
          break;
        }
        if (dashboard && (
          !!user.view !== !!dashboard.view ||
          !!user.edit !== !!dashboard.edit ||
          !!user.delete !== !!dashboard.delete
        )) {
          hasChanges = true;
          break;
        }
      }
    };

    this.setState({hasChanges});
  }

  applyFilter = filter => {
    this.setState({ filter, page: 1 }, this.getUsers);
  };

  applySort = sort => {
    this.setState({ sort, page: 1 }, this.getUsers);
  };

  onSearch = e => {
    this.setState({ search: e.target.value, page: 1 }, this.getUsersThrottled);
  };

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getUsers);
  };

  getUsers = () => {
    const { filter, sort, search, page } = this.state;
    const { id } = this.props.routeParams;
    this.props.getUsers({ filter, sort, search, page, id });
  };

  saveUsers = () => {
    const model = this.formatModel();
    this.props.saveUsers(model);
  };

  formatModel = () => {
    const { model } = this.state;
    const { users } = this.props;
    const { id } = this.props.routeParams;

    const data = _(model.users)
      .filter(u => !u.manageDashboards && !u.manageDashboardsViewOnly)
      .filter(u => {
        const user = _.find(users, { userId: u.userId });
        if (!user) return false;
        const dashboard = _.find(user.dashboards, { dashboardId: id })
        if (!dashboard && (u.view || u.edit || u.delete)) {
          return true;
        }
        if (dashboard && (
          !!u.view !== !!dashboard.view ||
          !!u.edit !== !!dashboard.edit ||
          !!u.delete !== !!dashboard.delete
        )) {
          return true;
        }
      }).map(u => {
        const user = _.find(users, { userId: u.userId });
        const dashboards = _.filter(user.dashboards, d => d.dashboardId !== id)
        const dashboard = _.find(user.dashboards, { dashboardId: id });
        if (u.view || u.edit || u.delete) {
          if (dashboard) {
            dashboard.view = u.view;
            dashboard.edit = u.edit;
            dashboard.delete = u.delete;
            dashboards.push(dashboard);
          } else {
            dashboards.push({
              dashboardId: id,
              view: u.view,
              edit: u.edit,
              delete: u.delete
            });
          }
        }
        return {
          ...user,
          dashboards
        }
      }).value();

    return { users: data };
  }

  isManageDashboards = (userId) => {
    const { users } = this.props;
    const user = _.find(users, { userId });
    return user && (user.manageDashboards || user.manageDashboardsViewOnly);
  };

  isDisabled = (userId, access) => {
    const { permissions, self, routeParams } = this.props;
    const { users } = this.state.model;
    const user = userId && _.find(users, { userId });
    if (user && userId === self) {
      return true;
    }
    if (user && (user.manageDashboards || user.manageDashboardsViewOnly)) {
      return true;
    }
    if (permissions.manageDashboards || permissions.manageDashboardsViewOnly) {
      return !(access === 'view' || (permissions.manageDashboards));
    } else {

      if (userId) {
        const dashboard = _.find(permissions.dashboards, { dashboardId: routeParams.id });
        if (dashboard) {
          return !dashboard[access] || (
            access === 'view' && (
              this.isChecked(userId, 'edit') && this.isDisabled(userId, 'edit') ||
              this.isChecked(userId, 'delete') && this.isDisabled(userId, 'delete')
            ))
        }
      } else {
        return _.some(users, u => {
          return this.isDisabled(u.userId, access);
        })
      }
    }
    return true; 
  }

  isChecked = (userId, access) => {
    const { users } = this.state.model;
    const user = _.find(users, { userId });
    if (user.manageDashboards) {
      return true;
    }
    if (user.manageDashboardsViewOnly) {
      return access == 'view';
    }
    return (user[access] || (access === 'view' && (user['edit'] || user['delete'])));
  }

  toggleFilter = () => {
    document.getElementById('filter-content').classList.toggle('shown');
  };

  renderSelected = type => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type]
    });
    return selected ? selected.name : '';
  };

  handleAllChecked = e => {
    const model = this.state.model;
    const name = e.name.substring(0, e.name.indexOf('All'));
    _.forEach(this.props.users, u => {
      const user = _.find(model.users, { userId: u.userId });
      if (user && !user.manageDashboards && !user.manageDashboardsViewOnly) {
        if (!e.checked) {
          delete user[name];
        } else {
          user[name] = true;
        }
      }
    });

    this.setState({
      model,
      [e.name]: e.checked
    }, this.checkChanges);
  };

  handleCheck = (e, userId) => {
    const { model } = this.state;
    const user = _.find(model.users, { userId });
    if (user) {
      if (!e.checked) {
        delete user[e.name];
      } else {
        user[e.name] = true;
      }
    }

    const allSelected = this.checkIfAllSelected(model.users, e.name);
    this.setState({ [`${e.name}All`]: allSelected, model }, this.checkChanges);
  };

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 20, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }

    return (
      <ul className="pagination">
        {pages.currentPage > 1 && (
          <li aria-label="First" onClick={() => this.goto(1)}>
            <a role="button" href="#">
              «
            </a>
          </li>
        )}
        {pages.currentPage > 1 && (
          <li aria-label="Prev" onClick={() => this.goto(pages.currentPage - 1)}>
            <a role="button" href="#">
              ‹
            </a>
          </li>
        )}
        {pages.pages.map((p, i) => {
          return (
            <li className={p === pages.currentPage && 'active'} key={i} onClick={() => this.goto(p)}>
              <a role="button" href="#">
                {p}
              </a>
            </li>
          );
        })}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Next" onClick={() => this.goto(pages.currentPage + 1)}>
            <a role="button" href="#">
              ›
            </a>
          </li>
        )}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Last" onClick={() => this.goto(pages.totalPages)}>
            <a role="button" href="#">
              »
            </a>
          </li>
        )}
      </ul>
    );
  };

  render() {
    const disabledTooltip = (
      <Tooltip id="flowstats-tooltip" className="tooltip_white">
        This user has manage dashboards permission
      </Tooltip>
    );

    const { isLoading, total } = this.props;
    const { users } = this.state.model;
    const { hasChanges } = this.state;

    return (
      <React.Fragment>
        <Header key="1" title="" showHome={true} />
        <div key="2" id="create-account" className='bg_dashboard'>
          <Helmet>
            <title>{pageTitle('Edit permissions')}</title>
          </Helmet>
          <div className='user_container permissions'>
            <div className="action-btn-list">
              <Confirm
                onConfirm={ev => this.saveUsers()}
                body={
                  <p>
                    Are you sure you want to save these permissions?
                  </p>
                }
                confirmText="Save permissions"
                confirmClass="btn-primary"
                icon={saveIcon}
                title="Edit permissions"
              >
                <Button variant='secondary' disabled={!hasChanges}>
                  <img src={saveIcon} alt="" />
                  Save permissions
                </Button>
              </Confirm>
            </div>
            <div className='table-content table-card'>
              <div className='table-filter'>
                <h5>{this.state.name}</h5>
                <div className="u-di form-group">
                  <Form.Group controlId="filter" className="filter-dropdown">
                    <DropdownButton
                      className="form-control-dropdown"
                      id="dropdown-item-button"
                      title={this.renderSelected('filter')}
                    >
                      {this.state.filterOptions.map((f, i) => {
                        return (
                          <Dropdown.Item
                            key={i}
                            as="button"
                            className={this.state.filter === f.value && 'active' }
                            onClick={() => this.applyFilter(f.value)}>
                            {f.name}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Form.Group>
                  <div className='search-wrap'>
                    <input
                      name="search"
                      placeholder="Search"
                      type="text"
                      id="Search"
                      className="form-control"
                      value={this.state.search}
                      onChange={this.onSearch}
                    />
                  </div>
                </div>
                {/*<div className='filter-button' onClick={this.toggleFilter}>
                  <img alt="filter" src={filterImage} />
                </div>*/}
              </div>

              <div className='table-scroll'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>
                        <div className='flex'>
                          User name
                          <Form.Group controlId="sort" className="filter-dropdown">
                            <DropdownButton
                              className="form-control-dropdown-sort"
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortName.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={ this.state.sort === s.value && 'active' }
                                    onClick={() => this.applySort(s.value)}>
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th>
                        <div className='flex'>
                        User email
                          <Form.Group controlId="sort" className="filter-dropdown">
                            <DropdownButton
                              className="form-control-dropdown-sort"
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortEmail.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={ this.state.sort === s.value && 'active' }
                                    onClick={() => this.applySort(s.value)}>
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th>
                        <CheckBox
                          id="viewAll"
                          name="viewAll"
                          label="View"
                          disabled={this.isDisabled(undefined, 'view')}
                          checked={this.state.viewAll}
                          onChange={this.handleAllChecked}
                        />
                      </th>
                      <th>
                        <CheckBox
                          id="editAll"
                          name="editAll"
                          label="Edit"
                          disabled={this.isDisabled(undefined, 'edit')}
                          checked={this.state.editAll}
                          onChange={this.handleAllChecked}
                        />
                      </th>
                      <th>
                        <CheckBox
                          id="deleteAll"
                          name="deleteAll"
                          label="Delete"
                          disabled={this.isDisabled(undefined, 'delete')}
                          checked={this.state.deleteAll}
                          onChange={this.handleAllChecked}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((u) => {
                      const disabled = u.manageDashboards || u.manageDashboardsViewOnly;

                      const viewChecked = this.isChecked(u.userId, 'view');
                      const editChecked = this.isChecked(u.userId, 'edit');
                      const deleteChecked = this.isChecked(u.userId, 'delete');

                      const viewDisabled = this.isDisabled(u.userId, 'view');
                      const editDisabled = this.isDisabled(u.userId, 'edit');
                      const deleteDisabled = this.isDisabled(u.userId, 'delete');

                      return (
                        <tr key={u.userId}>
                          <td>{u.pending ? '(no name)' : u.name}</td>
                          <td>
                            <div className='flex'>
                              {u.pending ? (!!u.invitationEmail ? u.invitationEmail : u.email) : u.email}
                              {disabled && (
                                <OverlayTrigger placement="top" overlay={disabledTooltip}>
                                  <span className='more_info'></span>
                                </OverlayTrigger>
                              )}
                            </div>
                          </td>
                          <td>
                            <CheckBox
                              id="view"
                              name="view"
                              label="View"
                              disabled={viewDisabled}
                              readonly={viewDisabled}
                              checked={viewChecked}
                              onChange={e => this.handleCheck(e, u.userId)}
                            />
                          </td>
                          <td>
                              <CheckBox
                                id="edit"
                                name="edit"
                                label="Edit"
                                disabled={editDisabled}
                                readonly={editDisabled}
                                checked={editChecked}
                                onChange={e => this.handleCheck(e, u.userId)}
                              />
                          </td>
                          <td>
                              <CheckBox
                                id="delete"
                                name="delete"
                                label="Delete"
                                disabled={deleteDisabled}
                                readonly={deleteDisabled}
                                checked={deleteChecked}
                                onChange={e => this.handleCheck(e, u.userId)}
                              />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            {total > 0 && this.renderPagination()}
          </div>
        </div>
        {isLoading && (
          <div className='table-loading loader-delay'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getDashboards: () => dispatch(getDashboards()),
    getUsers: opt => dispatch(getUsers(opt)),
    saveUsers: opt => dispatch(saveUsers(opt)),
  };
};

const mapStateToProps = state => {
  return {
    permissions: state.auth.user.permissions,
    self: state.auth.user._id,
    dashboards: state.boards.boards,
    isLoading: state.permissions.loading,
    users: state.permissions.users,
    page: state.permissions.page,
    total: state.permissions.total,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Permissions));
